import styled from 'styled-components';

export const FAQSection = styled.section`
  margin: 2.5rem auto 4rem;
`;

export const FAQHeading = styled.h2`
  margin: 0 0 1.6rem;
  font-size: 2rem;
  line-height: 1.25;
  font-weight: 700;
  color: #0e2238;
`;

export const FAQList = styled.div``;

export const FAQItem = styled.div`
  border-bottom: 1px solid #d6dde4;

  &:last-child {
    border-bottom: 0;
  }
`;

export const FAQQuestionButton = styled.button`
  width: 100%;
  border: 0;
  background: transparent;
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  text-align: left;
  cursor: pointer;
  font-size: 1.8rem;
  line-height: 1.3;
  color: #0e2238;
  font-weight: 600;
`;

export const FAQQuestion = styled.h3`
  margin: 0;
`;

export const FAQToggle = styled.span`
  flex-shrink: 0;
  color: #0073aa;
  font-size: 1.8rem;
  line-height: 1;
`;

export const FAQAnswer = styled.p<{ $isOpen: boolean }>`
  margin: 0 0 2.5rem;
  padding: 1rem 0;
  font-size: 1.6rem;
  line-height: 1.45;
  color: #0e2238;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
`;

export const FAQAnswerList = styled.ul<{ $isOpen: boolean }>`
  margin: -1.5rem 0 2.5rem;
  padding-left: 2rem;
  font-size: 1.6rem;
  line-height: 1.45;
  color: #0e2238;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
`;
